import { render, staticRenderFns } from "./MaterialInfo.vue?vue&type=template&id=4be0ae6b&"
import script from "./MaterialInfo.vue?vue&type=script&lang=js&"
export * from "./MaterialInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports